import Utility from "../../utilities/Utility";
import BaseDialog from "./BaseDialog";
import ItemList from "../../form_components/ItemList";
import map from "lodash/map";
import { CodeEditor } from "../../form_components";
import { InputIcon } from "@platform/ui-library";
import { isEqual } from "lodash";

export default class CustomFunctionDialog extends BaseDialog {
    state = {
        name: this.props.context?.getConfig?.("name") ?? "Untitled function",
        value: this.props.context.props.context.props.value?.[this.props.context.props?.varIdx ?? -1]?.script ?? ""
    };

    /**
     * Dialog for defining reusable function with arguments and function script
     * @module CustomFunctionDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.addHandle = this.handleAdd.bind(this);
        this.deleteHandle = this.handleDelete.bind(this);
        this.parameters = this.props.context?.getConfig?.("parameters") ?? [];
    }

    /**
     * Add to application
     * @param event
     */
    handleAdd() {
        const value = this.state.value;
        const contextProps = this.props.context?.props;
        const isNew = this.props.new;

        const config = {
            name: this.state.name,
            parameters: this.parameters,
            script: value
        }
        const timeStamps = {
            id: this.props.context?.getConfig?.("id") ?? Utility.uuid4(),
            lastLocalChange: window.apm.timestamp,
            createdTime: contextProps?.data?.createdTime ?? window.apm.timestamp,
            ...(!isNew && contextProps?.data?.lastSavedChange ? { lastSavedChange: contextProps.data.lastSavedChange} : {})
        }

        if(isNew) {
            this.props.context.add({ ...config, ...timeStamps });
            w2popup.close();
            return;
        }

        const idx = contextProps.varIdx;
        const oldConfig = {
            name: this.props.context?.getConfig?.("name") ?? '',
            parameters: contextProps.context.props.value[idx].parameters ?? [],
            script: contextProps.context.props.value[idx].script ?? ''
        };

        if(isEqual(config, oldConfig)) {
            return;
        }
        this.props.context.setConfig("script", { ...config, ...timeStamps });

        w2popup.close();
    }

    /**
     * Remove from application
     * @param event
     */
    handleDelete() {
        this.props.context.remove();
        w2popup.close();
    }

    /**
     * Set config proxy
     * @param {string} key
     * @param {string|Object} value
     */
    setConfig(key, value) {
        switch (key) {
            case "parameters":
                this.parameters = value;
                const functionTitle = this.getDomSelf().find(".function-title");
                functionTitle.text(this.getScriptHeader());
                break;
            default:
                this.setState({ [key]: value });
                break;
        }
    }

    componentDidMount() {
        super.componentDidMount();
        document.addEventListener("ev-dialog-add", this.addHandle);
        document.addEventListener("ev-dialog-delete", this.deleteHandle);
        document.addEventListener("ev-item-list-update", this.updateHandle);
    }

    unregister() {
        document.removeEventListener("ev-dialog-add", this.addHandle);
        document.removeEventListener("ev-dialog-delete", this.deleteHandle);
        document.removeEventListener("ev-item-list-update", this.updateHandle);
    }

    /**
     * Get function "argument" part for display
     * @returns {string}
     */
    getScriptHeader() {
        var serializedParams = "";
        const params = map(this.parameters, p => {
            return p.key + (p.value ? " = " + p.value : "");
        });
        if (params.length) {
            serializedParams = params.join(", ");
        }
        return "function (" + serializedParams + ") {";
    }

    /**
     * Get function "closure" part for display
     * @returns {string}
     */
    getScriptFooter() {
        return "}";
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div className="container-fluid">
                <div className="script-header" style={{ display: "block" }}>
                    <div style={{ fontWeight: "normal" }}>
                        <InputIcon label={window.l.popup.function_name}
                            context={this} value={this.state.name} required onChange={(e) => this.setConfig('name', e.target.value)} />
                        <ItemList label={window.l.popup.parameters} view={"keyValue"}
                            context={this} valKey={"parameters"} value={this.parameters}
                            pairKeyView={{ type: "Input", key: "key", hint: window.l.popup.parameter_name }}
                            pairValueView={{ type: "Input", key: "value", hint: window.l.popup.default_value }}
                            icon={"arrow-left"} allowDelete={true} broadcast={true} />
                    </div>
                    <div className="function-title">{this.getScriptHeader()}</div>
                </div>
                <div className="script-wrapper">
                    <CodeEditor value={this.state.value} onChange={(value) => this.setConfig('value', value)} />
                </div>
                <div className="script-footer" style={{ minHeight: "15px" }}>
                    {this.getScriptFooter()}
                </div>
            </div>
        );
    }
}